import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { Flex } from 'reflexbox'
import { Element } from 'react-scroll'

import RoleTable from 'containers/Admin/PartnerSite/PartnerSiteSelection/index'
import RoleDialog from 'containers/Admin/PartnerSite/PartnerSiteRole/index'
import PartnerSiteAddDialog from 'containers/Admin/PartnerSite/PartnerSiteAddDialog/index'
import PartnerSiteProductFamily from 'containers/Admin/PartnerSite/PartnerSiteProductFamily/index'
import PartnerSiteProductFamilyDialog from 'containers/Admin/PartnerSite/PartnerSiteProductFamily/ProductFamilyDialog'
import ProductFamilyAddDialog from 'containers/Admin/PartnerSite/PartnerSiteProductFamily/ProductFamilyAddDialog'

import styles from './styles.scss'

class MainPanel extends Component {
  render() {
    return (
      <Flex id='scrollContainer' column auto styleName='mainPanel'>
        <Element name='Partner Site Roles'>
          <RoleTable/>
          <RoleDialog/>
          <PartnerSiteAddDialog/>
        </Element>

        <Element name='Partner Site Product Family Roles'>
          <PartnerSiteProductFamily />
          <PartnerSiteProductFamilyDialog />
          <ProductFamilyAddDialog />
        </Element>
      </Flex>
    )
  }
}

export default CSSModules(MainPanel, styles)
